import { render, staticRenderFns } from "./geomagnetic-info.vue?vue&type=template&id=f5cdc1ba&scoped=true&"
import script from "./geomagnetic-info.vue?vue&type=script&lang=js&"
export * from "./geomagnetic-info.vue?vue&type=script&lang=js&"
import style0 from "./geomagnetic-info.vue?vue&type=style&index=0&id=f5cdc1ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cdc1ba",
  null
  
)

export default component.exports